class Subscription {
    static getSearchKey() {
        return 'subscriptionId';
    }

    static fromRaw(raw) {
        let subscription = new Subscription();
        subscription.uuid = raw.uuid;
        subscription.name = raw.name;
        subscription.state = raw.state;
        // subscription.accountId = raw.procurementAccountId;
        // subscription.isBillingAccountViewer = raw.isCurrentUserBillingAccountViewer;
        // subscription.managerUrl = raw.managerUrl;

        return subscription;
    }
}

module.exports = Subscription;



// WEBPACK FOOTER //
// ./src/azurebackup/model/Subscription.js